module.exports = __webpack_public_path__ + "static/img/gpt36.a3619c89.png";